// Module
var code = "Si vous avez cliqué par erreur, <a href=\"{reaboUrl}\" data-cy=\"cancel-unsubscribe\" style=\"text-decoration:underline;cursor:pointer\" target=\"_blank\">cliquez ici</a> pour continuer à recevoir nos emails.";
// Exports
module.exports = code;